import { APP_INITIALIZER, NgModule } from '@angular/core';
import { LocationStrategy, PathLocationStrategy, CommonModule } from '@angular/common';

import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { CoreModule } from '@core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';

import { AppConfigService } from '@services/others/app-config.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDateFormats, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

const APP_DATE_FORMAT: MatDateFormats = {
  parse: {
    dateInput: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    },
  },
  display: {
    dateInput: {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    },
    monthYearLabel: {
      year: 'numeric',
      month: 'long',
    },
    dateA11yLabel: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    monthYearA11yLabel: {
      year: 'numeric',
      month: 'long',
    }
  }
};

export function servicesOnRun(config: AppConfigService) {
  return () => config.load();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CoreModule,
    NgxPermissionsModule.forRoot(),
    MatNativeDateModule
  ],
  providers: [
    {
      // Quitamos el # de las rutas
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMAT },
    {
      // Angular CDK 22 renderiza los overlays (mat-dialog, menús, etc.) en el
      // "top layer" nativo del navegador vía el atributo popover. Ese layer
      // queda siempre por encima de cualquier elemento posicionado con
      // z-index normal, así que librerías ajenas a Angular como SweetAlert2
      // (usada por NotificationService) quedaban invisibles detrás de
      // cualquier diálogo/menú abierto. Se desactiva para volver al
      // stacking por z-index de siempre.
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false }
    },
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: servicesOnRun,
      multi: true,
      deps: [AppConfigService]
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
